import { Stack } from "@mui/material";

export type AdditionalQuestionsForGroupProps = {
  children: React.ReactNode;
};

export const AdditionalQuestionsForGroup = ({ children }: AdditionalQuestionsForGroupProps) => {
  return (
    <Stack direction="column" gap={2}>
      {children}
    </Stack>
  );
};
